import { TemplateStage2Form } from './TemplateStage2Form';

export default TemplateStage2Form;